
import './App.css';
import Body from './Components/Body';
import Navbar from './Components/Navbar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  return (
    <div className="App">
   <Navbar /> 
  
   <ToastContainer />
    </div>
  );
}

export default App;
